import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TID } from "@/lib/testIds";
import { statusClass, relativeTime } from "@/lib/format";
import { Bot, Cog, Router, MessageSquare } from "lucide-react";

const ICONS = {
  Orchestrator: Cog,
  Gateway: Router,
  "Worker ClickUp": Bot,
  "Bot Telegram": MessageSquare,
};

export default function Agents() {
  const [agents, setAgents] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .get("/agents")
      .then((r) => setAgents(r.data.items))
      .catch((e) => setErr(e?.response?.data?.detail || e.message));
  }, []);

  return (
    <div data-testid={TID.agentsPage} className="space-y-4">
      <p className="text-sm text-neutral-400 max-w-2xl">
        Vista <span className="font-mono text-neutral-300">read-only</span> degli agenti Org3 che
        alimentano Structura. Stato heartbeat aggiornato.
      </p>

      {err && (
        <div className="border border-red-900/60 bg-red-950/20 px-4 py-3 font-mono text-xs text-red-300">
          {err}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {agents.map((a) => {
          const Icon = ICONS[a.name] || Bot;
          const dot =
            a.status === "UP" ? "bg-[#4ADE80]" : a.status === "DEGRADED" ? "bg-[#F5A623]" : "bg-red-400";
          return (
            <div
              key={a.id}
              data-testid={TID.agentCard}
              className="border border-[#1F1F1F] bg-[#0C0C0C]"
            >
              <header className="border-b border-[#1F1F1F] px-4 py-3 flex items-center justify-between bg-[#141414]">
                <div className="flex items-center gap-2">
                  <Icon className="w-4 h-4 text-neutral-400" strokeWidth={1.5} />
                  <span className="font-mono text-[10px] tracking-[0.24em] uppercase text-neutral-400">
                    {a.id}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`w-2 h-2 rounded-full ${dot}`}></span>
                  <span className={`font-mono text-[9px] uppercase tracking-widest border px-1.5 py-0.5 ${statusClass(a.status)}`}>
                    {a.status}
                  </span>
                </div>
              </header>
              <div className="p-4 space-y-3">
                <h3 className="font-heading uppercase text-xl tracking-tight">{a.name}</h3>
                <p className="text-sm text-neutral-300">{a.role}</p>

                <div className="grid grid-cols-2 gap-3 pt-2 border-t border-[#1F1F1F]">
                  <div>
                    <div className="font-mono text-[9px] tracking-[0.24em] uppercase text-neutral-500 mb-1">tech</div>
                    <div className="font-mono text-xs text-neutral-300">{a.tech}</div>
                  </div>
                  <div>
                    <div className="font-mono text-[9px] tracking-[0.24em] uppercase text-neutral-500 mb-1">throughput 24h</div>
                    <div className="font-mono text-xs text-[#EDEDED]">
                      {a.throughput_24h?.toLocaleString?.("it-IT") ?? 0}
                    </div>
                  </div>
                  <div>
                    <div className="font-mono text-[9px] tracking-[0.24em] uppercase text-neutral-500 mb-1">last heartbeat</div>
                    <div className="font-mono text-xs text-neutral-300" title={a.last_heartbeat}>
                      {relativeTime(a.last_heartbeat)}
                    </div>
                  </div>
                  {a.issue && (
                    <div>
                      <div className="font-mono text-[9px] tracking-[0.24em] uppercase text-[#F5A623] mb-1">issue</div>
                      <div className="font-mono text-xs text-[#F5A623]">{a.issue}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
